<script lang="ts">
  import { fly } from 'svelte/transition'

  export let error: string | string[]
</script>

<div class="field-error" in:fly={{ y: -8 }}>
  {(Array.isArray(error) && error[0]) || error}
</div>

<style lang="scss">
  .field-error {
    font-size: 0.8125rem;
    color: var(--color-error);
    margin: 0.375em 0 0 0;
  }
</style>
